import { render, staticRenderFns } from "./util.vue?vue&type=template&id=8e3f68b6&scoped=true&lang=pug&"
import script from "./util.vue?vue&type=script&lang=js&"
export * from "./util.vue?vue&type=script&lang=js&"
import style0 from "./util.vue?vue&type=style&index=0&id=8e3f68b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3f68b6",
  null
  
)

/* custom blocks */
import block0 from "~/lang/user?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230324173659%2Fcomponents%2Fsite%2Fnav%2Futil.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports